import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';
import carriersFactory from './carriers';
import { carrierInterface } from './carriers';
import clientSidebarLinksFactory from './clientSidebarLinks';
import { ClientSidebarLink } from './clientSidebarLinks';
import customerSupportIntegrationFactory from './customerSupportIntegration';
import { integrationSetting, nullIntegrationSetting, updateIntegrationSettingForm} from './customerSupportIntegration';
import domainFactory from './domain';

export default (axios: AxiosInstance = baseAxios): { carriers: { fetchCarriers: () => Promise<carrierInterface[]>; }; clientSidebarLinks: { updateClientSidebarLinks: (links: ClientSidebarLink[]) => Promise<void>; }; customerSupportIntegration: { getIntegrationSetting: () => Promise<integrationSetting | nullIntegrationSetting>; updateIntegrationSetting: (form: updateIntegrationSettingForm) => Promise<void>; clearIntegrationSetting: () => Promise<void>; }; domain: { fetchDomainStatus: () => Promise<string>; }; } => ({
    carriers: carriersFactory(axios),
    clientSidebarLinks: clientSidebarLinksFactory(axios),
    customerSupportIntegration: customerSupportIntegrationFactory(axios),
    domain: domainFactory(axios),
});
